import React from 'react';
import styled, { keyframes, css } from 'styled-components';
// import FirstNameIcon from '../../assets/formComponents/FirstNameIcon.svg';
// import EmailIcon from '../../assets/formComponents/emailIcon.svg';
// import CompanyIcon from '../../assets/formComponents/companyIcon.svg';
// import PhoneIcon from '../../assets/formComponents/phone.svg';
// import Partners from '../../assets/v2/signup_partners.svg';
// import CompanyIcon from '../../assets/formComponents/companyIcon.svg';
import Caprev from '../../assets/v2/caprev.png';
import apiHost from '../../apiHost';
import Recaptcha from 'react-recaptcha';
import { validatePhone } from '../../globalFunctions';
import { BlueButton, H1, H2, SectionParent } from '../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Fade from 'react-reveal/Fade';
import { CountrySelect } from '@atlaskit/select';
import EsperLogoBlue from '../../assets/v2/esper_light.svg';
// import googleLogo from '../../assets/v2/signup/google_logo.svg';
import Check from '../../assets/v2/signup/check.svg';
import axios from 'axios';
import { Link, navigate, StaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import { isWorkEmail } from '../../domains';
import { Title } from '../Esper/HomePage/HomepageSectionOne';
import digital from '../../assets/v2/Product/digital.svg';
import eld from '../../assets/v2/Product/eld.svg';
import kioskdevice from '../../assets/v2/Product/kioskdevice.svg';
import pos from '../../assets/v2/Product/pos.svg';
import rugged from '../../assets/v2/Product/rugged.svg';
import smartphone from '../../assets/v2/Product/smartphone.svg';
import student from '../../assets/v2/Product/student.svg';
import tablet from '../../assets/v2/Product/tablet.svg';
import telehealth from '../../assets/v2/Product/telehealth.svg';
import smartfitness from '../../assets/v2/Product/smartfitness.svg';
import Checkbox from '../UIComponents/Checkbox';

const PartnerWithUsForm = styled.form`
  /* margin: auto; */
  display: grid;
  width: fit-content;
  justify-items: left;
  border-radius: 4px;
  padding: 50px;
  z-index: 2;
  box-shadow: 0 2px 21px 0 rgba(41, 35, 58, 0.12);
  background: #fff;

  @media (max-width: 520px) {
    padding: 28px;
  }
`;
const barberpole = keyframes`
  100% {
    background-position: 100% 100%;
  }
`;

export const BlueButtonNew = styled(BlueButton)`
  background-color: #664eab;
  min-width: 360px;
  margin-top: -1rem;
  justify-self: left;
  height: 40px;
  /* @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  } */
  width: 100%;
  background-image: ${(props: { isLoading: boolean }) =>
    props.isLoading
      ? `repeating-linear-gradient(
      -45deg,
      #7a55a5,
      #7a55a5 1rem,
      #634487 1rem,
      #634487 2rem
    )`
      : ''};

  animation: ${(props: { isLoading: boolean }) =>
    props.isLoading
      ? css`
          ${barberpole} 4s linear reverse infinite
        `
      : ''};
  background-size: 200% 200%;
  /* justify-self: center; */

  @media (max-width: 768px) {
    font-size: 16px !important;
    min-width: 18rem;
  }
`;

// @ts-ignore
export const StyledInputs = styled.input`
  :active {
    color: #000;
    background-color: #f4f5f7;
    border: rgb(76, 154, 255) 2px solid;
    outline: 0;
    box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
    background-image: ${(props: { error: boolean; backgroundImage?: any }) =>
      props.backgroundImage
        ? `url(${props.backgroundImage})`
        : 'none'} !important;
  }
  background-color: #f4f5f7;
  background-position-x: 0.4rem;
  background-image: ${(props: { error: boolean; backgroundImage?: any }) =>
    props.backgroundImage
      ? `url(${props.backgroundImage})`
      : 'none'} !important;
  box-shadow: ${(props: { error: boolean; backgroundImage?: any }) =>
    props.error ? '0 0 0 0.1rem #fd7e7e5e' : 'none'};
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  @media (max-width: 520px) {
    font-size: 12px;
  }
  line-height: 1.43;
  ::placeholder {
    color: #000;
  }
  :-internal-autofill-selected {
    background-color: rgb(232, 240, 254) !important;
    background-image: ${(props: { error: boolean; backgroundImage: any }) =>
      props.backgroundImage
        ? `url(${props.backgroundImage})`
        : 'none'} !important;
    color: #000 !important;
  }
  padding: 1.07em 0.5em;
  margin-top: 10px;
  height: 40px;
  width: 100%;
  /* min-width: 18rem; */
  border: solid 2px #000;
  border-color: ${(props: { error: boolean; backgroundImage: any }) =>
    props.error ? '#eb6161' : 'rgba(107, 124, 147, 0.43)'} !important;
  padding: ${(props: { error: boolean; backgroundImage: any }) =>
    props.backgroundImage
      ? `0.475rem 0.75rem 0.475rem 1.5rem`
      : '0.475rem 0.75rem 0.475rem 0.75rem'};
  border-radius: 4px;
  background-position-y: center;
  background-position-x: 0.5rem;
  opacity: 0.7;
  background-repeat: no-repeat;
  text-indent: ${(props: { error: boolean; backgroundImage: any }) =>
    props.backgroundImage ? `20px` : 'none'};
  background-size: 18px 18px;
  /* @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  } */
`;

const ImgWrapper = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
`;

const ImgHolder = styled(LazyLoadImage)`
  height: fit-content;
  width: fit-content;
  box-shadow: 0 1px 3px 0 rgba(41, 35, 58, 0.35);

  /*@media (max-width: 1125px) {
    height: 70px;
    width: 130px;
  }

  @media (max-width: 950px) {
    height: 55px;
    width: 100px;
  }

  @media (min-width: 415px) and (max-width: 768px) {
    height: 90px;
    width: 140px;
  }

  @media (max-width: 414px) {
    height: 85px;
    width: 150px;
  }

  @media (max-width: 400px) {
    height: 70px;
    width: 130px;
  }

  @media (max-width: 374px) {
    height: 55px;
    width: 100px;
  }*/
`;

const PhoneInput = styled.div`
  grid-column: span 1;
  margin-top: -6px;
  width: calc(100% + 2.5rem);
  margin-left: -2.5rem;
  @media (max-width: 768px) {
    margin-left: 15px;
    width: unset;
  }
`;

export const ImgDesktop = styled(GatsbyImage)`
  justify-self: center;
  margin-bottom: 2rem;
  width: 50%;
  max-width: 200px;
`;

const FormComponent = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-self: center;
  min-height: calc(100vh - 5rem);
  padding-top: 5rem !important;
  background-image: linear-gradient(to bottom, #fafbfe 0%, #fafbfe 99%);
  grid-template-columns: repeat(9, 1fr);
  justify-items: center;
`;

const FormComponentLeft = styled.div`
  padding: 0rem 6rem;
  display: grid;
  align-content: center;
  grid-column: span 4;
  justify-items: center;
  margin-bottom: 9rem;

  @media (max-width: 1440px) {
    padding: 0rem 3rem;
  }
  @media (max-width: 768px) {
    padding: 0rem 3rem;
    border-radius: 8px 8px 0px 0px;
    grid-column: span 9;
  }
  @media (max-width: 520px) {
    padding: 0rem;
  }
  @media (max-width: 400px) {
    padding: 0rem 2rem;
  }
`;

const FormComponentRight = styled.div`
  grid-column: span 5;
  /* background: #ffffff; */
  display: grid;
  /* width: 100%; */
  @media (max-width: 768px) {
    grid-column: span 9;
  }
`;

const FormComponentRightContainer = styled.div`
  display: grid;
  align-content: center;
  align-self: center;
  justify-content: center;
  position: relative;
  padding: 0rem 2rem 0rem 3rem;
  min-height: calc(100% - 238px);
  @media (max-width: 768px) {
  }
  @media (max-width: 520px) {
    padding: 8px;
  }
`;
const IAgreeText = styled.div`
  color: #424769;
  font-size: 16px;
  text-align: left;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-left: 0em;
  margin-top: 2rem;
  margin-bottom: 1.4rem;
  padding-left: 51px;

  @media (max-width: 520px) {
    text-align: center;

    padding-left: 28px;
  }
`;

const HaveAccount = styled(IAgreeText)`
  margin-top: 0rem;
  margin-bottom: 0rem;
  padding-left: 0px;
  color: #fff;
  a {
    color: #fff;
    font-weight: bold;
  }
  justify-self: right;
  @media (max-width: 520px) {
    padding-left: 0px;
  }
`;

const EsperLogoContainer = styled(SectionParent)`
  background: #735cbd;
  z-index: 4;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;

  box-shadow: 0 2px 21px 0 rgba(41, 35, 58, 0.12);
`;

const EsperLogo = styled(Link)``;

const SignUpHeading = styled(H1)`
  margin-top: 0rem;
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;

  margin-bottom: 0px;
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 1rem;
    text-align: left;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;
export const PasswordMatchError = styled.div`
  font-size: 12px;
  color: #c62828;
  margin-top: 6px;
  text-align: left;
  height: 21px;
  font-family: 'Nunito Sans', sans-serif;
`;
const CreditText = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  margin-left: 3rem;
  color: #41c8b1;
  font-size: 16px;
  /* margin-top: 0.5rem; */
  font-weight: normal;
  margin-bottom: 0.5rem;
  /* padding-left: 51px; */
  @media (max-width: 520px) {
    margin-left: 0rem;
    text-align: center;
    justify-self: center;
  }
`;

const FormComponentLeftTitleGreen = styled(Title)`
  font-stretch: normal;
  line-height: 1.27;
  font-size: 26px !important;
  letter-spacing: normal;
  text-align: left;
  color: #151828;
  margin-bottom: 1.3rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-top: -2rem;
    margin-bottom: 2rem;
    font-size: 18px !important;
    text-align: center;
  }
`;

const FormText = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  color: #735cbe;
  max-width: 330px;
  font-size: 16px;
  margin-top: 0.5rem;
  font-weight: normal;
  margin-bottom: 0rem;
  /* padding-left: 51px; */
  @media (max-width: 520px) {
    text-align: center;
    justify-self: center;
  }
`;

const FormComponentLeftList = styled.ul`
  /* margin-left: 40px; */
  padding-left: 0.5em;
  list-style: none;
  @media (max-width: 768px) {
    display: none;
  }
  @media (min-width: 1401px) {
    width: 130%;
  }
`;

const FormComponentLeftListItem = styled.li`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
  }
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #626679;
  background: url(${Check}) no-repeat;
  padding: 0.3em 0px 0.1em 30px;
  background-size: 18px;
  background-position-y: center;
  @media (max-width: 320px) {
    font-size: 16px;
  }
`;

const FieldsContainer = styled.div`
  margin-top: 2rem;
  width: 100%;
  @media (max-width: 580px) {
    /* width: 80%; */
  }
`;
const Circle = styled.div`
  height: 200px;
  width: 200px;
  position: absolute;
  top: -10%;
  z-index: 1;
  right: -10%;
  background: #e0f0ff;

  @media (max-width: 520px) {
    display: none;
  }
  border-radius: 50%;
`;
const SmallCircle = styled(Circle)`
  height: 20px;
  width: 20px;
  top: 200px;
`;
const Label = styled.label`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  margin-bottom: 0px;
`;
const SecondSection = styled.div`
  display: grid;
  justify-items: center;
  opacity: ${(props: any) => (props.isSelected ? 1 : 0.3)};
  transition: 0.5s opacity cubic-bezier(0.21, 0.69, 0.63, 0.43);
  pointer-events: ${(props: any) => (props.isSelected ? 'unset' : 'none')};
  user-select: ${(props: any) => (props.isSelected ? 'unset' : 'none')};
  max-width: 100%;
`;

const RadioSpan = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  margin-left: 5px;
  margin-right: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4b5176;
`;

const DeviceItem = styled.div`
  display: grid;
  grid-column: span 1;
  justify-content: center;
  margin-top: 2rem;
  margin-right: 2rem;
  @media (max-width: 1200px) {
    grid-column: span 2;
    margin-bottom: 2rem;
  }

  @media (max-width: 520px) {
    grid-column: span 5;
    margin-bottom: 2rem;
  }
`;

const DeviceText = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  padding-top: 1rem;
  display: grid;
  align-items: start;
  min-height: 4rem;
`;

const ItemWrapper = styled.div`
  padding-top: 25px;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Item = styled.div`
  display: inline-block;
  margin-left: 15px;
  margin-right: auto;
  @media (max-width: 414px) {
    margin: auto;
  }
`;

interface IState {
  fullName: string;
  fullNameError: boolean;
  email: string;
  emailError: boolean;
  emailErrorText: string;
  company: string;
  companyError: boolean;
  defaultCountry: any;
  signupEmailError: boolean;
  contactErrorMessage: string;
  contactNumber: string;
  contactError: boolean;
  sending: boolean;
  errorText: string;
  signUpError: boolean;
  recaptchaError: boolean;
  recaptchaErrorText: string;
  recaptchaComponent: React.ReactElement;
  contactFocus: boolean;
  consentCheckbox: boolean;
  consentError: boolean;
}
export default class EsperSignUpClass extends React.PureComponent<any, IState> {
  state = {
    fullName: '',
    fullNameError: false,
    lastName: '',
    lastNameError: false,
    email: '',
    contactErrorMessage: '',
    password: '',
    contactNumber: '',
    defaultCountry: {
      icon: '🇺🇲',
      name: 'United States',
      abbr: 'US',
      code: '1',
      suggested: true,
    },
    contactError: false,
    companyError: false,
    confirmPassword: '',
    company: '',
    contactFocus: false,
    emailError: false,
    signupEmailError: false,
    emailErrorText: '',
    passwordLengthError: false,
    sending: false,
    errorText: '',
    signUpError: false,
    recaptchaError: false,
    recaptchaErrorText: '',
    recaptchaComponent: <div />,
    firstFormSubmitted: false,
    consentCheckbox: false,
    consentError: false,
  };

  onload = () => {
    console.log('Recaptcha Loaded');
  };

  recaptchaInstance: any;

  resetRecaptcha = () => {
    this.recaptchaInstance.reset();
  };

  handleCountrySelect = (event: any) => {
    this.setState({ defaultCountry: event });
  };

  executeCaptcha = (event?: any) => {
    event.preventDefault();
    if (this.state.consentCheckbox || this.props?.messages?.locale === 'en') {
      // event.preventDefault();
      this.recaptchaInstance.reset();
      this.recaptchaInstance.execute();
    } else {
      this.setState({
        consentError: true,
      });
    }
  };

  handlefullNameChange = (event: any) =>
    this.setState({ fullName: event.target.value });

  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });

  handleContactChange = (event: any) =>
    this.setState({ contactNumber: event.target.value });

  handleCompanyChange = (event: any) =>
    this.setState({ company: event.target.value });

  getCookieValue = (name: string) => {
    const found = document.cookie
      .split(';')
      .filter((c) => c.trim().split('=')[0] === name);
    return found.length > 0 ? found[0].split('=')[1] : undefined;
  };

  validateEmail = (isNotOnFocus?: boolean) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === true && this.state.email.length < 150) {
      axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Signup Form`,
          phoneNumber: this.state.contactNumber,
          companyName: this.state.company,
          failure: false,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
      if (isWorkEmail(this.state.email.toLowerCase())) {
        console.log('isNotf', isNotOnFocus);
        if (isNotOnFocus) {
          this.setState({
            emailError: false,
            signupEmailError: false,
            emailErrorText: '',
          });
        } else {
          this.setState({
            emailError: false,
            signupEmailError: false,
            emailErrorText: '',
          });
          axios({
            url: `${apiHost.host}collect-emails`,
            method: 'POST',
            data: {
              email: this.state.email.trim().toLowerCase(),
              page: `Signup`,
              failure: false,
              url: window.location.href,
            },
          })
            .then((result: any) => {
              this.setState({
                emailError: false,
                signupEmailError: false,
                emailErrorText: '',
              });
            })
            .catch((error: any) => {
              if (
                error.response &&
                error.response.data &&
                error.response.data &&
                error.response.data.code === 4001
              ) {
                this.setState(
                  {
                    signupEmailError: true,
                    emailErrorText: this.props.messages
                      ?.AllFormValidationMessagesAccountExists,
                  },
                  () => console.log('true-lol')
                );
              } else {
                this.setState({
                  emailError: false,
                  signupEmailError: false,
                  emailErrorText: '',
                });
              }
            });
        }
      } else {
        this.setState(
          {
            emailError: true,
            emailErrorText: this.props.messages
              ?.AllFormValidationMessagesWorkEmail,
          },
          () => console.log('true-lol-pop')
        );
      }
    } else {
      this.setState({
        emailError: true,
        emailErrorText: this.props.messages?.AllFormValidationMessagesWorkEmail,
      });
    }
  };

  validateFullName = () => {
    if (this.state.fullName.length === 0 || this.state.fullName.length > 30) {
      this.setState({
        fullNameError: true,
      });
    } else {
      this.setState({
        fullNameError: false,
      });
    }
  };

  validateCompany = () => {
    if (this.state.company.length === 0 || this.state.company.length > 30) {
      this.setState({
        companyError: true,
      });
    } else {
      this.setState({
        companyError: false,
      });
    }
  };

  validateContactNumber = () => {
    if (!validatePhone(this.state.contactNumber)) {
      this.setState({
        contactError: true,
        contactFocus: true,
        contactErrorMessage: this.props.messages
          ?.AllFormValidationMessagesValidPhoneNumber,
      });
    } else {
      this.setState({
        contactError: false,
        contactFocus: true,
        contactErrorMessage: '',
      });
    }
  };

  isAllValid = () =>
    !(
      this.state.companyError ||
      this.state.contactError ||
      this.state.fullNameError ||
      this.state.emailError
    );

  validateAll = () => {
    this.validateCompany();
    this.validateContactNumber();
    this.validateEmail(true);
    this.validateFullName();
  };

  sendData = (token: any) => {
    this.validateAll();
    if (this.isAllValid()) {
      const hubspotToken = this.getCookieValue('hubspotutk');
      this.setState({ sending: true });
      axios({
        url: `${apiHost.host}signup`,
        method: 'POST',
        data: {
          name: this.state.fullName.trim(),
          companyName: this.state.company.trim(),
          phoneNumber: `${
            this.state.defaultCountry
              ? `+${this.state.defaultCountry.code} `
              : ''
          }${this.state.contactNumber.trim()}`,
          ABTestId: '0000',
          authProvider: 'basic',
          signupSource: 'Signup',
          isDeveloper: false,
          email: this.state.email.trim().toLowerCase(),
          recaptchaToken: token,
          hubspotTrackingCode: hubspotToken,
          pageUri: window.location.href,
          pageName: document.title,
        },
      })
        .then((response: any) => {
          sessionStorage.setItem('url', response.data.data.url);
          this.setState({ sending: false }, () => {
            window.location.href =
              this.props.currentLanguage && this.props.currentLanguage !== 'en'
                ? `/${this.props.currentLanguage}/thankyou`
                : '/thankyou';
          });
        })
        .catch((error: any) => {
          console.log('here');
          this.setState({ sending: false });
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.fields
          ) {
            if (error.response.data.fields['body.name']?.message) {
              this.setState({
                fullNameError: true,
              });
            }
            if (error.response.data.fields['body.companyName']?.message) {
            }
            if (error.response.data.fields['body.phoneNumber']?.message) {
            }
            if (error.response.data.fields['body.email']?.message) {
              this.setState({
                signupEmailError: true,
                emailErrorText:
                  error.response.data.fields['body.email']?.message ===
                  'Email already exists'
                    ? this.props.messages.AllFormValidationMessagesAccountExists
                    : 'Please enter valid email address',
              });
            }
            // error.response.data.forEach((item: any) => {
            //   if (item.code === 1001) {
            //     this.setState({
            //       fullNameError: true,
            //     });
            //   } else if (item.code === 1002) {
            //     this.setState({
            //       signupEmailError: true,
            //       emailErrorText: 'Please enter your work email',
            //     });
            //   } else if (item.code === 1005) {
            //     this.setState({
            //       signupEmailError: true,
            //       emailErrorText:
            //         'Sorry, an account was already created with this Email address',
            //     });
            //   } else if (item.code === 1004) {
            //     this.setState({
            //       recaptchaError: true,
            //       recaptchaErrorText: item.message,
            //     });
            //   }
            // });
          } else {
            this.setState({
              errorText: 'Something went wrong',
              signUpError: true,
            });
          }
        });
    } else {
      axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Signup Form`,
          failure: true,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
    }
  };

  handleGoogleSignin = (event: any) => {
    if (event) {
      event.preventDefault();
    }
    const hubspotToken = this.getCookieValue('hubspotutk');
    window.location.replace(
      `https://id.esper.io/sso/v2/signup?source=${encodeURI(
        window.location.origin
      )}&is_developer=${false}&hutk=${hubspotToken}&pageUri=${encodeURI(
        window.location.href
      )}&pageName=${encodeURI(document.title)}`
    );
  };

  handleFocusContact = () => this.setState({ contactFocus: true });

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            andi: file(relativePath: { eq: "v2/signup/andi-signup@3x.png" }) {
              childImageSharp {
                fluid(quality: 85) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <>
            <EsperLogoContainer>
              <EsperLogo
                aria-label="Esper Logo"
                title="Esper Logo"
                to={`${
                  this.props?.messages?.locale !== 'en'
                    ? `/${this.props?.messages?.locale}/`
                    : '/'
                }`}
              >
                <LazyLoadImage
                  alt="Esper logo"
                  style={{
                    height: '44px',
                    width: '180px',
                    marginTop: '1rem',
                    marginBottom: '1rem',
                  }}
                  src={EsperLogoBlue}
                />
              </EsperLogo>

              <HaveAccount>
                {this.props.messages?.SignupPageHaveAnAccount1}{' '}
                <Link
                  id="sign-in-bottom"
                  rel="preconnect"
                  to={
                    this.props.currentLanguage &&
                    this.props.currentLanguage !== 'en'
                      ? `/${this.props.currentLanguage}/login`
                      : '/login'
                  }
                >
                  {this.props.messages?.SignupPageHaveAnAccount2}
                </Link>{' '}
              </HaveAccount>
            </EsperLogoContainer>
            <FormComponent style={this.props.style}>
              <FormComponentLeft>
                <div>
                  <FormComponentLeftTitleGreen>
                    {this.props.messages?.locale !== 'en'
                      ? this.props.messages?.SignupPageTitle
                      : 'Industry’s Most Powerful Platform for Android Device Deployment and Application Management.'}
                  </FormComponentLeftTitleGreen>
                  <FormComponentLeftList>
                    <FormComponentLeftListItem>
                      {this.props.messages?.SignupPagePoint1}
                    </FormComponentLeftListItem>
                    <FormComponentLeftListItem>
                      {this.props.messages?.SignupPagePoint2}
                    </FormComponentLeftListItem>
                    <FormComponentLeftListItem>
                      {this.props.messages?.SignupPagePoint3}
                    </FormComponentLeftListItem>
                    <FormComponentLeftListItem>
                      {this.props.messages?.SignupPagePoint4}
                    </FormComponentLeftListItem>
                    <FormComponentLeftListItem>
                      {this.props.messages?.SignupPagePoint5}
                    </FormComponentLeftListItem>
                    <FormComponentLeftListItem>
                      {this.props.messages?.SignupPagePoint6}
                    </FormComponentLeftListItem>
                    {this.props.messages?.SignupPagePoint7 && (
                      <FormComponentLeftListItem>
                        {this.props.messages?.SignupPagePoint7}
                      </FormComponentLeftListItem>
                    )}
                  </FormComponentLeftList>
                  <ItemWrapper>
                    <Item>
                      <ImgWrapper>
                        <ImgHolder src={Caprev} />
                      </ImgWrapper>
                    </Item>
                  </ItemWrapper>
                </div>
              </FormComponentLeft>
              <FormComponentRight>
                <FormComponentRightContainer>
                  <Circle />
                  <SmallCircle />
                  <Recaptcha
                    ref={(el: any) => {
                      this.recaptchaInstance = el;
                    }}
                    className="g-recaptcha"
                    onloadCallback={this.onload}
                    size="invisible"
                    sitekey="6Lc6vr0UAAAAALbCkvhwF3jqTmvbadpnRcGgz6eu"
                    verifyCallback={this.sendData}
                  />
                  {this.props.messages?.locale !== 'en' ? (
                    <CreditText>
                      {this.props.messages?.SignupPageFormNoCreditCard}
                    </CreditText>
                  ) : (
                    <CreditText>No credit card required</CreditText>
                  )}

                  <PartnerWithUsForm>
                    {this.props.messages?.locale !== 'en' ? (
                      <>
                        <SignUpHeading>
                          {this.props.messages?.SignupPageFormTitle}
                        </SignUpHeading>
                        <FormText>
                          {this.props.messages?.SignupPageStarterPackTitle}
                        </FormText>
                      </>
                    ) : (
                      <>
                        <SignUpHeading>Start Free Trial</SignUpHeading>
                        <FormText>
                          {this.props.messages?.SignupPageStarterPackTitle}
                        </FormText>
                      </>
                    )}
                    <SecondSection isSelected={true}>
                      <FieldsContainer>
                        <div style={{ display: 'grid' }}>
                          <Label>
                            {this.props.messages?.SignupPageFormEmail}
                          </Label>
                          <StyledInputs
                            id="email"
                            value={this.state.email}
                            aria-label="Email"
                            // backgroundImage={EmailIcon}
                            maxLength={149}
                            onChange={this.handleEmailChange}
                            onBlur={() => this.validateEmail(false)}
                            error={
                              this.state.emailError ||
                              this.state.signupEmailError
                            }
                            type="email"
                            // placeholder={'Work Email'}
                            name="Work Email"
                          />
                          <Fade
                            when={
                              this.state.emailError ||
                              this.state.signupEmailError
                            }
                          >
                            <PasswordMatchError id="email-error">
                              {this.state.emailError === false &&
                              this.state.signupEmailError ? (
                                <>
                                  <i
                                    className="fa fa-exclamation-triangle"
                                    aria-hidden="true"
                                  />{' '}
                                  {this.state.emailErrorText}
                                </>
                              ) : (
                                this.state.emailError && (
                                  <>
                                    {' '}
                                    <i
                                      className="fa fa-exclamation-triangle"
                                      aria-hidden="true"
                                    />{' '}
                                    {this.state.email.length > 1
                                      ? this.state.emailErrorText
                                        ? this.state.emailErrorText
                                        : this.props.messages
                                            ?.AllFormValidationMessagesValidEmail
                                      : this.props.messages
                                          ?.AllFormValidationMessagesEmail}
                                  </>
                                )
                              )}
                            </PasswordMatchError>
                          </Fade>
                        </div>
                        <div
                          style={{
                            display: 'grid',
                          }}
                        >
                          <Label>
                            {this.props.messages?.SignupPageFormName}
                          </Label>
                          <StyledInputs
                            id="full-name"
                            aria-label="Full name"
                            error={this.state.fullNameError}
                            onBlur={this.validateFullName}
                            // backgroundImage={FirstNameIcon}
                            value={this.state.fullName}
                            maxLength={29}
                            onChange={this.handlefullNameChange}
                            // placeholder={'Full Name'}
                            type="text"
                            name="Full name"
                          />
                          <Fade when={this.state.fullNameError}>
                            <PasswordMatchError id="name-error">
                              {this.state.fullNameError === true && (
                                <>
                                  <i
                                    className="fa fa-exclamation-triangle"
                                    aria-hidden="true"
                                  />{' '}
                                  {this.state.fullName.length > 30
                                    ? 'Name should be below 30 characters'
                                    : this.props.messages
                                        ?.AllFormValidationMessagesName ??
                                      'Please enter the name'}
                                </>
                              )}
                            </PasswordMatchError>
                          </Fade>
                        </div>

                        <div
                          style={{
                            display: 'grid',
                          }}
                        >
                          <Label>
                            {this.props.messages?.SignupPageFormCompany}
                          </Label>
                          <StyledInputs
                            id="company-name"
                            aria-label="Company Name"
                            error={this.state.companyError}
                            // backgroundImage={CompanyIcon}
                            onBlur={this.validateCompany}
                            value={this.state.company}
                            maxLength={29}
                            onChange={this.handleCompanyChange}
                            // placeholder={`Company Name`}
                            type="text"
                            name="Company Name"
                          />
                          <Fade when={this.state.companyError}>
                            <PasswordMatchError id="company-error">
                              {this.state.companyError === true && (
                                <>
                                  <i
                                    className="fa fa-exclamation-triangle"
                                    aria-hidden="true"
                                  />{' '}
                                  {this.state.company.length > 30
                                    ? 'Company name should be below 30 characters'
                                    : this.props.messages
                                        ?.AllFormValidationMessagesCompany}
                                </>
                              )}
                            </PasswordMatchError>
                          </Fade>
                        </div>
                        <div
                          style={{ display: 'grid' }}
                          onMouseDown={this.handleFocusContact}
                        >
                          <Label
                            style={{
                              gridColumn: 'span 2',
                              marginBottom: '10px',
                            }}
                          >
                            {this.props.messages?.SignupPageFormNumber}
                          </Label>
                          <CountrySelect
                            value={this.state.defaultCountry}
                            onChange={this.handleCountrySelect}
                            placeholder="Country"
                          />
                          <PhoneInput>
                            <StyledInputs
                              id="contact"
                              value={this.state.contactNumber}
                              aria-label="Contact"
                              style={
                                this.state.contactError ||
                                this.state.signUpError
                                  ? {
                                      boxShadow: '0 0 0 0.1rem #fd7e7ec7',
                                      borderRadius: '4px',
                                      marginTop: '6px',
                                    }
                                  : { boxShadow: 'unset', marginTop: '6px' }
                              }
                              maxLength={149}
                              onChange={this.handleContactChange}
                              onBlur={this.validateContactNumber}
                              onFocus={this.handleFocusContact}
                              error={
                                this.state.contactError ||
                                this.state.signUpError
                              }
                              type="text"
                              name="contact"
                            />
                          </PhoneInput>
                          <PasswordMatchError
                            style={{ gridColumn: 'span 2' }}
                            id="contact-error"
                          >
                            {this.state.contactError === true && (
                              <>
                                <i
                                  className="fa fa-exclamation-triangle"
                                  aria-hidden="true"
                                />{' '}
                                {this.state.contactErrorMessage
                                  ? this.state.contactErrorMessage
                                  : 'Please enter the contact number'}
                              </>
                            )}
                          </PasswordMatchError>
                        </div>
                        {this.props.messages?.WebsiteConsentText1 ? (
                          this.props?.messages?.locale === 'de' ? (
                            <div
                              style={{
                                display: 'grid',
                                maxWidth: '420px',
                              }}
                            >
                              <Checkbox
                                label={
                                  <div
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: 'normal',
                                      lineHeight: 'normal',
                                      color: '#151828',
                                    }}
                                  >
                                    {this.props.messages?.WebsiteConsentText1}
                                    {this.props.currentLanguage !== 'en' ? (
                                      <span>
                                        <Link
                                          to={`${
                                            this.props?.messages?.locale !==
                                            'en'
                                              ? `/${this.props?.messages?.locale}/privacy-policy`
                                              : '/privacy-policy'
                                          }`}
                                        >
                                          {' '}
                                          {
                                            this.props.messages
                                              ?.WebsiteConsentText2
                                          }{' '}
                                        </Link>
                                        {
                                          this.props.messages
                                            ?.WebsiteConsentText3
                                        }
                                      </span>
                                    ) : null}
                                  </div>
                                }
                                checked={this.state.consentCheckbox}
                                onChange={() =>
                                  this.setState(
                                    {
                                      consentCheckbox: !this.state
                                        .consentCheckbox,
                                    },
                                    () =>
                                      this.setState({
                                        consentError:
                                          this.state.consentError &&
                                          !this.state.consentCheckbox
                                            ? true
                                            : false,
                                      })
                                  )
                                }
                              />
                              <Fade when={this.state.consentError}>
                                <PasswordMatchError id="consent-error">
                                  {this.state.consentError === true && (
                                    <>
                                      <i
                                        className="fa fa-exclamation-triangle"
                                        aria-hidden="true"
                                      />{' '}
                                      {
                                        this.props.messages
                                          ?.WebsiteConsentErrorValidationText
                                      }
                                    </>
                                  )}
                                </PasswordMatchError>
                              </Fade>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: 'grid',
                                maxWidth: '420px',
                              }}
                            >
                              <Checkbox
                                label={
                                  <div
                                    style={{
                                      fontSize: '14px',
                                      fontWeight: 'normal',
                                      lineHeight: 'normal',
                                      color: '#151828',
                                    }}
                                  >
                                    {this.props.messages?.WebsiteConsentText1}
                                    {this.props.currentLanguage !== 'en' ? (
                                      <span>
                                        <Link
                                          to={`${
                                            this.props?.messages?.locale !==
                                            'en'
                                              ? `/${this.props?.messages?.locale}/privacy-policy`
                                              : '/privacy-policy'
                                          }`}
                                        >
                                          {' '}
                                          {
                                            this.props.messages
                                              ?.WebsiteConsentText2
                                          }{' '}
                                        </Link>
                                        {
                                          this.props.messages
                                            ?.WebsiteConsentText3
                                        }
                                      </span>
                                    ) : null}
                                  </div>
                                }
                                checked={this.state.consentCheckbox}
                                onChange={() =>
                                  this.setState({
                                    consentCheckbox: !this.state
                                      .consentCheckbox,
                                  })
                                }
                              />
                            </div>
                          )
                        ) : null}

                        <div
                          style={{
                            marginBottom: '6px',
                          }}
                        >
                          {this.state.signUpError === true && (
                            <Fade>
                              <PasswordMatchError id="signup-error">
                                {' '}
                                <i
                                  className="fa fa-exclamation-triangle"
                                  aria-hidden="true"
                                />{' '}
                                {this.state.errorText
                                  ? this.state.errorText
                                  : `Seems like there's an issue with your signup, please try again later`}
                              </PasswordMatchError>
                            </Fade>
                          )}
                        </div>
                      </FieldsContainer>

                      <BlueButtonNew
                        style={{ textTransform: 'unset', marginTop: '10px' }}
                        isLoading={this.state.sending}
                        disabled={this.state.sending}
                        onClick={this.executeCaptcha}
                        id="homepage__signup_button"
                      >
                        {this.props.messages?.SignupPageFormCTA}
                      </BlueButtonNew>
                      {/* <IAgreeText>
                      <Link
                        id="terms-of-service"
                        rel="preconnect"
                        to="/terms-of-service/"
                      >
                        Terms of Service
                      </Link>{' '}
                      and{' '}
                      <Link
                        id="privacy-policy"
                        rel="preconnect"
                        to="/privacy-policy/"
                      >
                        Privacy Policy{' '}
                      </Link>
                    </IAgreeText> */}
                      {this.props.currentLanguage !== 'de' ? (
                        <div style={{ marginTop: '1rem' }}>
                          <p
                            style={{
                              fontSize: '14px',
                              fontWeight: 'normal',
                              lineHeight: 'normal',
                              color: '#151828',
                            }}
                          >
                            {this.props.messages?.WebsiteConsentText2}{' '}
                            <Link
                              id="terms-of-service"
                              rel="preconnect"
                              to="/terms-of-service/"
                            >
                              {this.props?.messages.WebsiteConsentText3}{' '}
                            </Link>
                            <Link
                              id="terms-of-service"
                              rel="preconnect"
                              to="/privacy-policy/"
                            >
                              {this.props?.messages.WebsiteConsentText4}
                            </Link>
                          </p>
                        </div>
                      ) : null}
                    </SecondSection>
                  </PartnerWithUsForm>

                  <IAgreeText>
                    {this.props.messages?.SignupPageUnableToSignup1}{' '}
                    <Link
                      id="contact-us-bottom"
                      rel="preconnect"
                      to={`${
                        this.props?.messages?.locale !== 'en'
                          ? `/${this.props?.messages?.locale}/contact-us`
                          : '/contact-us'
                      }`}
                    >
                      {this.props.messages?.SignupPageUnableToSignup2}
                    </Link>
                  </IAgreeText>
                </FormComponentRightContainer>
              </FormComponentRight>
              {(this.props.messages?.locale === 'en' ||
                !this.props.messages) && (
                <DeviceCard>
                  <DeviceBannerText>
                    Deploy, Monitor, and Manage Your Android Devices & Apps
                  </DeviceBannerText>
                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={kioskdevice}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>Kiosks</DeviceText>
                  </DeviceItem>
                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={rugged}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>Rugged</DeviceText>
                  </DeviceItem>
                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={pos}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>POS</DeviceText>
                  </DeviceItem>
                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={smartphone}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>Smartphones</DeviceText>
                  </DeviceItem>
                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={tablet}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>Tablets</DeviceText>
                  </DeviceItem>

                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={telehealth}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>Telehealth</DeviceText>
                  </DeviceItem>
                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={smartfitness}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>
                      Smart <br />
                      Fitness
                    </DeviceText>
                  </DeviceItem>

                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        style={{ height: '40px', width: '40px' }}
                        src={eld}
                      />
                    </ImgWrapper>
                    <DeviceText>ELDs</DeviceText>
                  </DeviceItem>

                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={student}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>
                      Student <br />
                      Devices
                    </DeviceText>
                  </DeviceItem>

                  <DeviceItem>
                    <ImgWrapper>
                      <ImgHolder
                        src={digital}
                        style={{ height: '40px', width: '40px' }}
                      />
                    </ImgWrapper>
                    <DeviceText>
                      Digital <br />
                      Signage
                    </DeviceText>
                  </DeviceItem>
                </DeviceCard>
              )}
              {!this.props.messages ? (
                <Footer>
                  © {'Copyright'} {new Date().getFullYear()}{' '}
                  {'Esper - All Rights Reserved'}
                </Footer>
              ) : (
                <Footer>
                  © {this.props.messages?.WebsiteGeneralCopyright1}{' '}
                  {new Date().getFullYear()}{' '}
                  {this.props.messages?.WebsiteGeneralCopyright2}
                </Footer>
              )}
              {/* <Footer>
                {this.props.messages?.WebsiteGeneralCopyright1}{' '}
                {new Date().getFullYear()}{' '}
                {this.props.messages?.WebsiteGeneralCopyright2}
              </Footer> */}
            </FormComponent>
          </>
        )}
      />
    );
  }
}

const Footer = styled.footer`
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  align-self: end;
  border-top: solid 1px rgba(116, 124, 157, 0.11);
  grid-column: span 9;
  width: 100vw;
`;

const DeviceCard = styled(SectionParent)`
  text-align: center;
  align-self: end;
  grid-column: span 9;
  width: 100vw;
  background-color: #03103b;
  display: grid;
  grid-template-columns: repeat(11, 1fr);
  @media (max-width: 1200px) {
    grid-template-columns: repeat(10, 1fr);
  }
`;

const DeviceBannerText = styled.span`
  width: 275px;
  height: 54px;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  margin-top: 2rem;
  margin-left: 2rem;
  @media (max-width: 1200px) {
    display: grid;
    grid-column: span 9;
    margin: 1rem auto 30px auto;
  }
`;
